import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { portfolioData } from '../mock';
import { useReveal } from '../hooks/useReveal';

const PublicationItem = ({ pub, index }) => {
  const [ref, visible] = useReveal();
  return (
    <a
      ref={ref}
      data-testid={`publication-${index}`}
      href={pub.link}
      target="_blank"
      rel="noopener noreferrer"
      className={`reveal ${visible ? 'is-visible' : ''} block group py-10 border-t border-[hsl(var(--rule))] hover:bg-[hsl(var(--surface))] transition-colors px-4 -mx-4 rounded-sm`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="grid md:grid-cols-12 gap-4 md:gap-8 items-start">
        <div className="md:col-span-2 mono text-xs text-[hsl(var(--foreground-faint))] pt-2">
          /{String(index + 1).padStart(2, '0')}
        </div>
        <div className="md:col-span-9 space-y-3">
          <h3 className="display text-2xl sm:text-3xl leading-tight group-hover:text-[hsl(var(--accent))] transition-colors">
            {pub.title}
          </h3>
          <p className="mono text-xs text-[hsl(var(--foreground-muted))]">
            {pub.venue}
          </p>
          <p className="text-lg text-[hsl(var(--foreground-muted))] leading-relaxed max-w-2xl">
            {pub.description}
          </p>
          <div className="flex flex-wrap gap-3 pt-1">
            {pub.tags.map((t, i) => (
              <span
                key={i}
                className="mono text-[0.7rem] text-[hsl(var(--foreground-faint))]"
              >
                #{t.toLowerCase().replace(/\s+/g, '-')}
              </span>
            ))}
          </div>
        </div>
        <div className="md:col-span-1 flex md:justify-end">
          <ArrowUpRight className="w-5 h-5 text-[hsl(var(--foreground-faint))] group-hover:text-[hsl(var(--accent))] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
        </div>
      </div>
    </a>
  );
};

const Publications = () => {
  return (
    <section
      id="publications"
      data-testid="publications-section"
      className="py-28 sm:py-36 px-5 sm:px-8 lg:px-12 border-t border-[hsl(var(--rule))] bg-[hsl(var(--surface))]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 mb-12">
          <div className="lg:col-span-4">
            <div className="section-label mb-6">
              <span>04 / writing</span>
            </div>
            <h2 className="display text-4xl sm:text-5xl leading-tight">
              Papers I've
              <br />
              been part of.
            </h2>
          </div>
          <div className="lg:col-span-8 lg:pt-3">
            <p className="text-xl text-[hsl(var(--foreground-muted))] leading-relaxed max-w-2xl">
              A small but growing list. Mostly applied work at the edge of ML, healthcare, and security.
            </p>
          </div>
        </div>

        <div>
          {portfolioData.publications.map((p, i) => (
            <PublicationItem key={p.id} pub={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
